package org.gymly.theme

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable

private val GymlyColorScheme = lightColorScheme(
    primary = GymlyColors.Primary,
    onPrimary = GymlyColors.OnPrimary,
    surface = GymlyColors.Surface,
    surfaceContainer = GymlyColors.SurfaceContainer,
    outline = GymlyColors.Outline,
    onSurface = GymlyColors.Text,
    onSurfaceVariant = GymlyColors.TextMuted,
    error = GymlyColors.Error,
)

@Composable
fun GymlyTheme(content: @Composable () -> Unit) {
    MaterialTheme(
        colorScheme = GymlyColorScheme,
        content = content,
    )
}
